const DATE_ONLY_RE = /^(\d{4})-(\d{2})-(\d{2})$/;

export const parseDateOnly = (value: string | Date): Date => {
  if (value instanceof Date) {
    return new Date(value.getFullYear(), value.getMonth(), value.getDate());
  }

  const match = DATE_ONLY_RE.exec(value);
  if (!match) return new Date(value);

  const [, year, month, day] = match;
  return new Date(Number(year), Number(month) - 1, Number(day));
};

export const formatDateOnly = (value: string | Date): string =>
  parseDateOnly(value).toLocaleDateString("es-AR");

export const formatDateKey = (value: string | Date): string => {
  const date = parseDateOnly(value);
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const day = String(date.getDate()).padStart(2, "0");
  return `${year}-${month}-${day}`;
};

export const formatDateOnlyRange = (start: string | Date, end: string | Date): string =>
  `${formatDateOnly(start)} - ${formatDateOnly(end)}`;

export const compareDateOnly = (a: string | Date, b: string | Date): number => {
  const left = parseDateOnly(a).getTime();
  const right = parseDateOnly(b).getTime();
  return left === right ? 0 : left > right ? 1 : -1;
};

export const daysBetweenDateOnly = (start: string | Date, end: string | Date): number => {
  const msPerDay = 24 * 60 * 60 * 1000;
  return Math.round((parseDateOnly(end).getTime() - parseDateOnly(start).getTime()) / msPerDay);
};

export const isDateOnlyInRange = (
  date: string | Date,
  start: string | Date,
  end: string | Date,
  includeEnd = false
): boolean => {
  const afterStart = compareDateOnly(date, start) >= 0;
  const beforeEnd = includeEnd ? compareDateOnly(date, end) <= 0 : compareDateOnly(date, end) < 0;
  return afterStart && beforeEnd;
};
